// extracted by mini-css-extract-plugin
module.exports = {"Loader":"spinner_Loader__3KBDB","load2":"spinner_load2__1vFcM"};